export default {
  name: 'PendingEnrollmentsPanel',
  props: ['course_id', 'pending_enrollments'],
  template: '#pending_enrollments_panel',
  methods: {
    approveStudent(item, index) {
      let self = this;
      let request = new Kadenze.AjaxRequest({
        type: 'POST',
        url: Kadenze.Routes.course_enroll_student_path(this.course_id, item.id),
        loadingIndicator: false
      });

      request.done(function(response) {
        self.pending_enrollments.splice(index, 1);
        new Kadenze.Notice.success({ message: response.message });
      });

      request.fail((xhr) => {
        new Kadenze.Notice.error({ message: xhr.responseText });
      });
    },

    denyStudent(item, index) {
      let self = this;
      let deletePrompt = 'Are you sure you want to deny ' + item.full_name + ' from this course?';
      Kadenze.UIUtil.confirmAction(deletePrompt, function() {
        let request = new Kadenze.AjaxRequest({
          type: 'POST',
          url: Kadenze.Routes.course_remove_student_path(self.course_id, item.id),
          loadingIndicator: false
        });

        request.done(function(response) {
          self.pending_enrollments.splice(index, 1);
          new Kadenze.Notice.success({ message: response.message });
        });

        request.fail((xhr) => {
          new Kadenze.Notice.error({ message: xhr.responseText });
        });
      });
    }
  }
};
